import { WarningOutlined } from "@ant-design/icons"
import { Tooltip } from "antd"
import styled from "styled-components"

import FormattedTextBlock from "#blocks/FormattedTextBlock"
import { type Hexcode, useThemeContext } from "#contexts/ThemeContextProvider"

const SNote = styled.div<{ color: Hexcode }>`
  cursor: pointer;
  transition: transform 0.25s ease-in-out;
  color: ${({ color }) => color};

  &:hover {
    transform: scale(1.3);
  }
`
const HoverableNote = ({ note }: { note: string | undefined }) => {
  const { eric } = useThemeContext()

  if (!note) return null

  const title = <FormattedTextBlock text={note} />

  return (
    <Tooltip title={title} mouseEnterDelay={0.15} mouseLeaveDelay={0.05}>
      <SNote color={eric.red}>
        <WarningOutlined />
      </SNote>
    </Tooltip>
  )
}

export default HoverableNote
